/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';
import { ArrayOfByte } from './arrayOfByte.schema';
import { BranchEnum } from './branchEnum.schema';

export const ScheduleSiteChangeRequestAssignmentDto = zod.object({
  "id": zod.string().uuid().optional(),
  "monthlyCoveragePlanId": zod.string().uuid().optional(),
  "mcpSiteAssignmentId": zod.string().uuid().optional(),
  "date": zod.coerce.date().optional(),
  "branchId": zod.lazy(() => BranchEnum).optional(),
  "branchName": zod.string().optional(),
  "fromSchedule": zod.coerce.date().optional(),
  "toSchedule": zod.coerce.date().optional(),
  "isDeleted": zod.boolean().optional(),
  "timestamp": zod.lazy(() => ArrayOfByte).optional()
});

export type ScheduleSiteChangeRequestAssignmentDto = zod.input<typeof ScheduleSiteChangeRequestAssignmentDto>;
export type ScheduleSiteChangeRequestAssignmentDtoOutput = zod.output<typeof ScheduleSiteChangeRequestAssignmentDto>;
